<template src="./houseKeepingDetailVue.template.html"></template>
<style>
  .modal-backdrop.show {
    opacity: 0.2 !important;
  }

  .Same {
    color: gray;
  }

  .LateCheckout,
  .EarlyCheckin {
    color: red;
  }

  .LateCheckin,
  .EarlyCheckout {
    color: green;
  }
</style>
<script>
  import moment from "moment-timezone";
  import foliomodal from "./../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
  export default {
    name: "HouseKeepingStatus",
    props: [],
    components: {
      foliomodal
    },
    data() {
      return {
        apiUrl:
          window.location.protocol +
          "//" +
          window.location.hostname +
          (window.location.port ? ":1339" : ""),
        status: null,
        loading: true,
        headerColumnList: {
          Unit: {
            Label: "Unit",
            IsChecked: true,
            ColumnName: "UnitName",
            class: "HKUnit",
            isAscOrDesc: null,
            sortLabels: {
              UnitName: {
                ColumnName: "UnitName",
                isSortLoading: false,
                Label: "Unit Name"
              },
              UnitClassName: {
                ColumnName: "UnitClassName",
                isSortLoading: false,
                Label: "Unit Class Name"
              }
            }
          },
          Assignment: {
            Label: "ASSIGNMENT",
            IsChecked: true,
            ColumnName: "Assignment",
            class: "HKassign"
          },
          PriorReservations: {
            Label: "Prior/Current Res",
            IsChecked: true,
            ColumnName: "Prior/CurrentRes",
            class: "HKpreRes HKpreResActions"
          },
          Housekeeping: {
            Label: "Housekeeping",
            IsChecked: true,
            ColumnName: "Housekeeping",
            class: "HKactions"
          },

          NextReservations: {
            Label: "Next Res",
            IsChecked: true,
            ColumnName: "NextRes",
            class: "HKnextRes HKnextResActions"
          }
          // notes: {
          //   Label: "Notes",
          //   IsChecked: true,
          //   ColumnName: "Notes",
          //   class: "HKnote"
          // }
        },
        houseKeepingList: {},
        reservationSummaryInfo: {},
        Reservation_Status: {},
        toggleFilterPanel: false,
        propertyList: [],
        unitClassList: [],
        propertyId: null,
        UnitClassId: null,
        userLogo: null,
        usersList: [],
        iconValue: null,
        currResObj: {},
        housekeepingListByDate: moment().format("DD MMM YYYY"),
        notesDetailList: [],
        functionId: null,
        // userEntitlementList: {},
        departedClassName: "",
        showNotes: false,
        noteObj: {},
        isTaskListEmpty: "",
        houseStatusList:[
          "All Units",
          "Arriving",
          "Departing",
          "Occupied",
          "Pending",
          "Scheduled",
          "Unoccupied"
        ],
        houseStatusValue: "All Units",
        hosueKeepingSelectedDate: null,
        userDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        loggedInUser: null,
        isModalVisible: false,
        modalParams: {},
        housekeepingData: {},
        housekeepingDataIndex: null,
        housekeepingDataStatus: null,
        displayUsersList: false,
        classRemoveIndex: null,
        EnableOccupiedUnitsButton: null
      };
    },

    methods: {

      FullNote(notesId) {
        console.log("FullNoteid", notesId);
        let vm = this;
        for (var i in vm.notesDetailList) {
          if (vm.notesDetailList[i].noteId == notesId) {
            vm.$set(vm.notesDetailList[i], "showFullNote", true);
            vm.$set(vm.notesDetailList[i], "showSubNote", false);
            console.log("vm.notesDetailList[i].showFullNote", vm.notesDetailList[i].showFullNote);
          }
        }
      },
      subNote(notesId) {
        let vm = this;
        for (var i in vm.notesDetailList) {
          if (vm.notesDetailList[i].noteId == notesId) {
            vm.$set(vm.notesDetailList[i], "showFullNote", false);
            vm.$set(vm.notesDetailList[i], "showSubNote", true);
          }
        }
      },

      showUsersList(indexVal) {
        let vm = this;
        setTimeout(function () {
          vm.classRemoveIndex = indexVal;
          let classsName = "#" + indexVal;
          $(classsName).addClass("show");
        }, 10);
      },
      makeOccuipedUnitsDirty() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Update_OccupiedUnits",
          params: {
            SelectedDate: vm.housekeepingListByDate
          },
          callback: function (err, response) {
            if (response) {
              console.log("Update_OccupiedUnits=>", response);
              vm.getHouseKeepinglist();
            }
          }
        });
      },
      imageURLS(imgGuid) {
        let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
        if (isBase64) {
          return imgGuid;
        }
        return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
      },

      addTaskTypeNameClass(statusName, inst) {
        if (statusName == "Clean") {
          return inst.unitDetails.tasktypeName;
        } else {
          return;
        }
      },
      switchView() {
        if (this.listType === "list") this.listType = "card";
        else this.listType = "list";
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
      },
      formatCurrentResDate(date) {
        return moment(date, "YYYY-MM-DD").format("MMM DD");
      },
      updateStartDate(key, dateObj, thisObj) {
        let vm = this;
        vm.housekeepingListByDate = dateObj
          ? dateObj.format("DD MMM YYYY")
          : null;
        console.log("vm.housekeepingListByDate222", vm.housekeepingListByDate);
        // vm.getHouseKeepinglist();
      },

      // to get the housekeeping tasks list
      getHouseKeepinglist() {
        let vm = this;
        vm.loading = true;
        // vm.houseKeepingList = [];
        vm.isTaskListEmpty = "";
        vm.hosueKeepingSelectedDate = vm.housekeepingListByDate;
        console.log("vm.functionId", vm.propertyId, ",", vm.UnitClassId);
        if (vm.housekeepingListByDate == "") {
          vm.housekeepingListByDate = moment().format("DD MMM YYYY");
          console.log("vm.housekeepingListByDate1111", vm.housekeepingListByDate);
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "getHouseKeepinglist",
          params: {
            ModuleAction: "getHouseKeepinglist",
            propertyId: vm.propertyId,
            UnitClassId: vm.UnitClassId,
            dateObjValue: moment(vm.housekeepingListByDate).format("YYYY-MM-DD"),
            functionId: vm.functionId,
            HouseStatus: vm.houseStatusValue,
            currentdate: moment().format("YYYY-MM-DD")
          },
          callback: function (err, response) {
            if (err) {
              console.log("getHouseKeepinglist", err);
              return;
            }
            if (response) {
              console.log("housekeeping listdata", response.unitDetails);
              if (jQuery.isEmptyObject(response.unitDetails)) {
                vm.loading = false;
                vm.houseKeepingList = {}
                vm.isTaskListEmpty = "No Task Items to display";
              } else {
                vm.houseKeepingList = response.unitDetails;
                // vm.houseKeepingList.splice(0, vm.houseKeepingList.length, ...response.unitDetails);
                vm.usersList = response.usersList;
                vm.EnableOccupiedUnitsButton =
                  response.EnableButton[0].EnableOccupiedUnitsButton;
                vm.loading = false;
                if (vm.displayUsersList) {
                  vm.displayUsersList = false;
                  setTimeout(function () {
                    let classsName = "#" + vm.housekeepingDataIndex;
                    $(classsName).addClass("show");
                  }, 10);
                }
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Rendered Housekeeping list Successfully!"
                });
              }
            }
          }
        });
      },
      closePopup() {
        let vm = this;
        vm.isModalVisible = false;
        vm.changeHousekeepingStatus(
          vm.housekeepingData,
          vm.housekeepingDataIndex,
          vm.housekeepingDataStatus
        );
      },
      taskStatus(inst, index, status) {
        let vm = this;
        vm.housekeepingData = inst;
        vm.housekeepingDataIndex = index;
        vm.housekeepingDataStatus = status;
        let usersList = inst.assignedUsers.map(user => user.userId);
        console.log("usersList", usersList);
        let checkUsers = usersList.includes(vm.loggedInUser);
        console.log("checkUsers", checkUsers);
        if (
          inst.previousAssignedUsers.length > 0 &&
          vm.userEntitlementList.fncHousekeepingInspector.isAssigned == -1 &&
          vm.userEntitlementList.fncHousekeeper.isAssigned == 1 &&
          vm.userEntitlementList.fncAssignHousekeeper.isAssigned == 1 &&
          inst.unitDetails.statusTypeName == null &&
          !checkUsers
        ) {
          vm.isModalVisible = true;
          vm.modalParams = {
            popupTitle: "Assign users",
            popupMessage: "Do you want to assign the task to yourself ?",
            yesButtontext: "Yes",
            noButtonText: "No",
            yesButtonCallback: vm.callForSave,
            noButtonCallback: vm.closePopup
          };
        } else {
          vm.isModalVisible = false;
          vm.changeHousekeepingStatus(inst, index, status);
        }
      },
      callForSave() {
        let vm = this;
        vm.isModalVisible = false;
        vm.displayUsersList = true;
        let usersclass = vm.housekeepingDataIndex;
        // let user = vm.usersList.filter(user => user.userId == vm.loggedInUser);
        // vm.houseKeepingList[vm.housekeepingDataIndex].assignedUsers.splice(
        //   1,
        //   vm.houseKeepingList[vm.housekeepingDataIndex].assignedUsers.length,
        //   user[0]
        // );
        // vm.housekeepingData.previousAssignedUsers = vm.houseKeepingList[vm.housekeepingDataIndex].assignedUsers
        // vm.assignHousekeepers(vm.housekeepingDataIndex);
        vm.changeHousekeepingStatus(
          vm.housekeepingData,
          vm.housekeepingDataIndex,
          vm.housekeepingDataStatus
        );
        this.classRemoveIndex = vm.housekeepingDataIndex;
        setTimeout(function () {
          let classsName = "#" + vm.housekeepingDataIndex;
          $(classsName).addClass("show");
        }, 10);
      },
      // saving the status on the workflow eg:dirty to clean or inspect-dirty
      changeHousekeepingStatus(inst, index, status) {
        let vm = this;
        if (inst.unitDetails.taskId) {
          let currentDate = moment().format("YYYY-MM-DD");
          let selectedDate = moment(vm.housekeepingListByDate).format(
            "YYYY-MM-DD"
          );
          let dateCheckCondition;
          if (vm.userEntitlementList.fncHousekeepingInspector.isAssigned == 1) {
            dateCheckCondition = moment(selectedDate).isSameOrBefore(currentDate);
          } else if (vm.userEntitlementList.fncHousekeeper.isAssigned == 1) {
            dateCheckCondition = moment(selectedDate).isSame(currentDate);
          }
          if (dateCheckCondition) {
            if (inst.previousAssignedUsers.length > 0) {
              if (inst.unitDetails.taskTypeId == 1) {
                if (inst.unitDetails.priorResStatusName == "Departed") {
                  if (
                    inst.unitDetails.unitId ==
                    vm.houseKeepingList[index].unitDetails.unitId
                  ) {
                    vm.updateTaskStatus(index, status);
                  }
                } else if (!inst.unitDetails.priorReservationId) {
                  if (
                    inst.unitDetails.unitId ==
                    vm.houseKeepingList[index].unitDetails.unitId
                  ) {
                    vm.updateTaskStatus(index, status);
                  }
                } else {
                  vm.$store.dispatch("toastr", {
                    type: "warning",
                    header: "Warning",
                    message:
                      "Unable to update status due to Prior/Current Reservation Unit Status is not Departed"
                  });
                }
              } else if (inst.unitDetails.taskTypeId == 2) {
                if (
                  inst.unitDetails.priorResStatusName == "In-House" ||
                  inst.unitDetails.priorResStatusName == "Departed"
                ) {
                  if (
                    inst.unitDetails.unitId ==
                    vm.houseKeepingList[index].unitDetails.unitId
                  ) {
                    vm.updateTaskStatus(index, status);
                  }
                } else if (!inst.unitDetails.priorReservationId) {
                  if (
                    inst.unitDetails.unitId ==
                    vm.houseKeepingList[index].unitDetails.unitId
                  ) {
                    vm.updateTaskStatus(index, status);
                  }
                } else {
                  vm.$store.dispatch("toastr", {
                    type: "warning",
                    header: "Warning",
                    message:
                      "Unable to update status due to Prior/Current Reservation Unit Status is not In-House or Departed"
                  });
                }
              }
            } else {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "Warning",
                message: "Unable to update status, please assign housekeeper(s)"
              });
            }
          } else {
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning",
              message: "Can't change status for this Date "
            });
          }
        } else {
          vm.updateTaskStatus(index, status);
        }
      },

      checkStatus(inst) {
        let vm = this;
        // console.log("inst===>",inst);
        if (
          vm.$store.state.userEntitlementList.fncHousekeeper.isAssigned == 1 &&
          vm.$store.state.userEntitlementList.fncHousekeepingInspector
            .isAssigned == -1 &&
          inst.unitDetails.statusTypeName === "Inspected"
        ) {
          return false;
        } else {
          return true;
        }
      },
      checkClean(inst) {
        let vm = this;
        if (
          vm.$store.state.userEntitlementList.fncHousekeepingInspector
            .isAssigned == 1 &&
          inst.unitDetails.statusTypeName === "Inspected"
        ) {
          return true;
        } else if (
          vm.$store.state.userEntitlementList.fncHousekeepingInspector
            .isAssigned == 1 &&
          inst.unitDetails.statusTypeName === "Dirty"
        ) {
          return false;
        }
      },
      updateTaskStatus(index, status) {
        let vm = this;
        vm.houseKeepingList[
          index
        ].unitDetails.statusTypeName = status.statusName.toString();
        vm.houseKeepingList[index].unitDetails.statusTypeId = status.statusTypeId;
        console.log(
          "vm.houseKeepingList[index].unitDetails.taskId==>",
          vm.houseKeepingList[index].unitDetails.taskId,
          vm.houseKeepingList[index].unitDetails.statusTypeId
        );
        vm.$store.dispatch("dataRequestHandler", {
          key: "updateTaskStatus",
          params: {
            ModuleAction: "updateTaskStatus",
            taskId: vm.houseKeepingList[index].unitDetails.taskId,
            statusTypeId: vm.houseKeepingList[index].unitDetails.statusTypeId,
            currentdate: vm.userDate,
            UnitId: vm.houseKeepingList[index].unitDetails.unitId
          },
          callback: function (err, response) {
            if (err) {
              console.log("updateTaskStatus", err);
              return;
            }
            if (response) {
              console.log("updateTaskStatus", response);
              // vm.usersList = response.recordsets[1];
              vm.getHouseKeepinglist();
              if (
                status.statusTypeId == 1 &&
                response.recordsets[1] &&
                response.recordsets[1][0] &&
                response.recordsets[1][0].LoggedInUser
              ) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message:
                    "Updated unit status to dirty by " +
                    response.recordsets[1][0].LoggedInUser
                });
              }
            }
          }
        });
      },
      panelCallback() {
        let vm = this;
        vm.getHouseKeepinglist();
        vm.showNotes = false;
      },
      showReservationSummaryPanel(resId, status) {
        let vm = this;
        console.log("resId", resId);
        if (
          vm.$store.state.userEntitlementList.fncReservationList.isAssigned === 1
        ) {
          this.currResObj = { ReservationId: resId };
          // vm.getHouseKeepinglist();
        }
      },

      // assignHousekeepers
      selectUser(e, index) {
        let vm = this;
        console.log("selectUser", vm.houseKeepingList[index].assignedUsers);
        if (e.target.checked) {
          for (var userIdIndex in vm.usersList) {
            if (e.target.value == vm.usersList[userIdIndex].userId) {
              vm.houseKeepingList[index].assignedUsers.push(
                vm.usersList[userIdIndex]
              );
              console.log("selectUser", vm.houseKeepingList[index].assignedUsers);
            }
          }
        } else {
          for (var userIdIndex in vm.usersList) {
            if (e.target.value == vm.usersList[userIdIndex].userId) {
              var unAssignedUserIndex = vm.houseKeepingList[
                index
              ].assignedUsers.findIndex(x => x.userId == e.target.value);
              vm.houseKeepingList[index].assignedUsers.splice(
                unAssignedUserIndex,
                1
              );
            }
          }
        }
      },
      assignHousekeepers(index) {
        let vm = this;
        console.log("usserLOGO", vm.houseKeepingList[index].assignedUsers);
        vm.$store.dispatch("dataRequestHandler", {
          key: "assignHousekeepers",
          params: {
            ModuleAction: "assignHousekeepers",
            taskId: vm.houseKeepingList[index].unitDetails.taskId,
            housekeepers: vm.houseKeepingList[index].assignedUsers
          },
          callback: function (err, response) {
            if (err) {
              console.log("assignHousekeepers", err);
              return;
            }
            if (response) {
              console.log("assignHousekeepers", response);
              // vm.houseKeepingList[index].showuserList = false;
              vm.getHouseKeepinglist();
            }
          }
        });
      },

      getPropertyMetaData: function () {
        // let scope = this;
        // console.log("scope.propertyId", scope.propertyId);
        // this.$store.dispatch("dataRequestHandler", {
        //   key: "GetPropertyMetaData",

        //   params: {
        //     ModuleAction: "GetPropertyMetaData",
        //     PropertyId: scope.propertyId
        //   },
        //   callback: function (err, response) {
        //     if (response) {
        //       console.log("response in getPropertyMetaData", response);
        //       scope.propertyList = response.recordsets[1];
        //       // scope.unitClassList = response.recordsets[2];
        //     } else {
        //       console.log(err);
        //     }
        //   }
        // });
        let scope = this;
        this.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (response) {
              scope.propertyList.splice(
                0,
                scope.propertyList.length,
                ...response.propertyList
              );
            } else {
              console.log(err);
            }
            scope.getUserEntities();
            // scope.fncTestHousekeepingStatus();
          }
        });
      },
      showUsersDropDown(index) {
        let vm = this;
        vm.houseKeepingList[index].showuserList = !vm.houseKeepingList[index]
          .showuserList;
      },

      // to get list of the users to the task assginment
      // getHousekeeperList() {
      //   let vm = this;
      //   vm.$store.dispatch("dataRequestHandler", {
      //     key: "getHousekeeperList",
      //     params: {
      //       ModuleAction: "getHousekeeperList"
      //     },
      //     callback: function(err, response) {
      //       if (err) {
      //         return;
      //       }
      //       if (response) {
      //         // console.log("getHousekeeperList", response.recordsets[1]);

      //         vm.usersList = response.recordsets[1];
      //         console.log("getHousekeeperList", vm.houseKeepingList[0].usersList)
      //       }
      //     }
      //   });
      // },
      getNoteDetailById(resId, status, event) {
        console.log(resId);
        let vm = this;
        console.log("this.$el.offsetHeight");
        let offset = $(event.currentTarget).offset();
        $(".modal-content").css("margin-top", offset.top);
        // $("#priorHKnotesModal").scrollTop(100);
        $("#priorHKnotesModal").animate({ scrollTop: offset.top }, 1000);
        $("#nextHKnotesModal").animate({ scrollTop: offset.top }, 1000);

        vm.notesDetailList = [];
        if (status == "Departed") {
          vm.departedClassName = "departedClassName";
        }
        // if(status != 'Departed'){
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_NotesDetails_forTasklist",
          params: {
            ModuleAction: "Get_NotesDetails",
            ReservationId: resId,
            NoteId: null
          },
          callback: function (err, response) {
            if (err) {
              console.log("getNoteDetailById", err);
              return;
            }
            if (response) {
              console.log("response in Get_NotesDetails by id", response);
              if (response[0]) {
                vm.notesDetailList = response[0];
                vm.notesDetailList.splice(
                  0,
                  vm.notesDetailList.length,
                  ...response[0]
                );

                // for (var i in vm.notesDetailList) {
                //   if (vm.notesDetailList[i].noteDetails && vm.notesDetailList[i].noteDetails != null && vm.notesDetailList[i].noteDetails.length > 100) {
                //     vm.notesDetailList[i].subNote = vm.notesDetailList[i].noteDetails.substr(0, 100);
                //     console.log("vm.notesDetailList[i].subNote", vm.notesDetailList[i].subNote);
                //     vm.$set(vm.notesDetailList[i], "showSubNote", true);



                //   }
                //   else if (vm.notesDetailList[i].noteDetails && vm.notesDetailList[i].noteDetails != null && vm.notesDetailList[i].noteDetails.length < 100) {
                //     vm.notesDetailList[i].fullNote = vm.notesDetailList[i].noteDetails;
                //     console.log("vm.notesDetailList[i].fullNote", vm.notesDetailList[i].fullNote);
                //     vm.$set(vm.notesDetailList[i], "showFullNote", false);

                //   }
                // }


              }
              // vm.notesTypeDropdown = response[1];
            }
          }
        });
        // }
      },
      displayUnitClassList() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUnitClasssListBySearchText",
          params: {
            searchText: null,
            PropertyId: vm.propertyId
          },
          callback: function (err, response) {
            if (err) {
              console.log("displayUnitClassList", err);
              return;
            }
            if (response) {
              console.log("responsevm.UnitClassId", response);
              console.log("responsevm.UnitClassId", vm.UnitClassId);
              vm.unitClassList.splice(
                0,
                vm.unitClassList.length,
                ...response.unitClassList
              );
              if (vm.unitClassList.length > 0) {
                for (var UnitClass of vm.unitClassList) {
                  if (UnitClass.UnitClassId == vm.UnitClassId) {
                    vm.UnitClassId = UnitClass.UnitClassId;
                  } else {
                    vm.UnitClassId = null;
                  }
                }
              } else {
                vm.UnitClassId = null;
              }
            }
          }
        });
      },
      fncTaskAssign(inst) {
        let vm = this;
        // if (inst.previousAssignedUsers.length == 0) {
        if (
          vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncAssignHousekeeper"
          ) &&
          vm.$store.state.userEntitlementList.fncAssignHousekeeper.isAssigned == 1
        ) {
          return false;
        } else {
          return true;
        }
        // } else if (inst.previousAssignedUsers.length > 0) {
        //   if (
        //     vm.$store.state.userEntitlementList.hasOwnProperty("fncTaskAssignUpdate") &&
        //     vm.$store.state.userEntitlementList.fncTaskAssignUpdate.isAssigned ==1)
        //   {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // }
      },
      GetUserEntitlementsAndDefaultProperty() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUserEntitlementsAndDefaultProperty",
          params: {
            ModuleAction: "GetUserEntitlementsAndDefaultProperty"
          },
          callback: function (err, response) {
            if (err) {
              console.log("GetUserEntitlementsAndDefaultProperty", err);
              return;
            }
            if (response) {
              console.log(
                "response in GetUserEntitlementsAndDefaultProperty",
                response
              );
              vm.userEntitlementList = response.userEntitlementList;
              vm.UserProperties = response.properties;
              vm.getUserEntities();
              // vm.fncTestHousekeepingStatus();
              // vm.DefaultProperty = response.defaultPropertyId;
            }
          }
        });
      },
      getUserEntities() {
        let vm = this;
        if (
          vm.userEntitlementList.hasOwnProperty("fncHousekeepingInspector") &&
          vm.userEntitlementList.hasOwnProperty("fncAssignHousekeeper") &&
          vm.userEntitlementList.hasOwnProperty("fncHousekeeper")
        ) {
          if (
            vm.userEntitlementList.fncHousekeepingInspector.isAssigned == 1 &&
            vm.userEntitlementList.fncAssignHousekeeper.isAssigned == 1 &&
            vm.userEntitlementList.fncHousekeeper.isAssigned == 1
          ) {
            vm.functionId = 0;
            vm.getHouseKeepinglist();
          } else if (
            vm.userEntitlementList.hasOwnProperty("fncHousekeepingInspector") &&
            vm.userEntitlementList.fncHousekeepingInspector.isAssigned == 1
          ) {
            vm.functionId = 0;
            vm.getHouseKeepinglist();
          } else if (
            vm.userEntitlementList.hasOwnProperty("fncAssignHousekeeper") &&
            vm.userEntitlementList.fncAssignHousekeeper.isAssigned == 1
          ) {
            vm.functionId = 0;
            vm.getHouseKeepinglist();
          } else if (
            vm.userEntitlementList.hasOwnProperty("fncHousekeeper") &&
            vm.userEntitlementList.fncHousekeeper.isAssigned == 1
          ) {
            vm.functionId = 1;
            vm.getHouseKeepinglist();
          }
        }
      },
      showNotesPanel(inst) {
        let vm = this;
        vm.showNotes = true;
        if (vm.$store.state.userEntitlementList.fncNotesSave.isAssigned === 1) {
          this.noteObj = {
            noteId: -1,
            resObj: inst,
            selectedDate: vm.housekeepingListByDate
          };
          // vm.getHouseKeepinglist();
        }
      },
      checkDates() {
        let vm = this;
        let currentDate = moment().format("YYYY-MM-DD");
        let selectedDate = moment(vm.hosueKeepingSelectedDate).format(
          "YYYY-MM-DD"
        );
        if (moment(selectedDate).isSame(currentDate)) {
          return false;
        } else {
          return true;
        }
      },
      checkFutureDates() {
        let vm = this;
        let currentDate = moment().format("YYYY-MM-DD");
        let selectedDate = moment(vm.hosueKeepingSelectedDate).format(
          "YYYY-MM-DD"
        );
        if (moment(selectedDate).isSameOrAfter(currentDate)) {
          return false;
        } else {
          return true;
        }
      },
      getUserProfile() {
        let vm = this;
        console.log("getUserProfile mounted");
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUserProfile",
          params: {},
          callback: function (err, response) {
            if (response) {
              console.log("loggedInUser=>", response);
              vm.loggedInUser = response[0][0].UserId;
            }
          }
        });
      }
    },

    computed: {
      fncNotes() {
        let vm = this;
        if (vm.$store.state.userEntitlementList.hasOwnProperty("fncNotesNew")) {
          if (vm.$store.state.userEntitlementList.fncNotesNew.isAssigned == 1) {
            return false;
          } else {
            return true;
          }
        }
      },
      fncHousekeepingInspector() {
        let vm = this;
        if (
          vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncHousekeepingInspector"
          )
        ) {
          return vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncHousekeepingInspector"
          )
            ? vm.$store.state.userEntitlementList.fncHousekeepingInspector
            : null;
        }
      },
      fncTaskUpdate() {
        let vm = this;
        if (
          vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncHousekeepingInspector"
          ) &&
          vm.$store.state.userEntitlementList.fncHousekeepingInspector
            .isAssigned == 1
        ) {
          return false;
        } else if (
          vm.$store.state.userEntitlementList.hasOwnProperty("fncHousekeeper") &&
          vm.$store.state.userEntitlementList.fncHousekeeper.isAssigned == 1
        ) {
          return false;
        } else {
          return true;
        }
      },
      userEntitlementList() {
        let entitlementList = this.$store.getters.getUserEntitlements();
        if (entitlementList && Object.keys(entitlementList).length > 0) {
          return entitlementList;
        }
        return {};
      }
    },

    mounted() {
      let vm = this;
      console.log("houseKeeping");
      // vm.GetUserEntitlementsAndDefaultProperty();
      vm.$store.dispatch("GetUserEntitlementsAndDefaultProperty");
      vm.getPropertyMetaData();
      vm.displayUnitClassList();
      // vm.getHousekeeperList();
      // vm.getHouseKeepinglist()
      vm.getUserProfile();

      $(document).click(function (e) {
        console.log("clicked on doc");
        let classsName = "#" + vm.classRemoveIndex;
        $(classsName).removeClass("show");
        // vm.showLedgerAccounts = false;
        // vm.showAmenitiesList =false;
      });
    }
  };
</script>